import type { ShopSlotView } from "@highmarch/app";
import { BalanceData, ShopId, isRandomItem } from "@highmarch/domain";
import { tagHtml } from "../components";
import { itemBlockHtml } from "../hub/itemBlock";
import { oddsHtml } from "../deals/pickSheet";
import { currencyIcon } from "./shopsArt";
import { FREE_PRICE, priceText, slotTile } from "./shopsModel";
import { itemWellOpts, tileRarity } from "./shopsTiles";
import { itemCardHtml } from "./itemCard";
import type { ItemPopup } from "./itemPopup";

/**
 * A Merchant, Event or VIP slot as the item popup (itemPopup.ts): what it is, where it goes, the odds of a random
 * item before paying (Apple 3.1.1), the struck base price of a discount, and the price on BUY (TAKE when free).
 * Markup only; whether it can be bought is the caller's (`blocked`).
 */

/** Item kinds that have a rarity to name (gold, gems and speed-ups only wear a size tint). */
const RARITY_KINDS: ReadonlySet<string> = new Set(["chest", "luckyChest", "gear"]);
/** The ribbon per shop. */
const SHOP_NAMES: Readonly<Record<ShopId, string>> = { merchant: "MYSTERY MERCHANT", event: "EVENT SHOP", vip: "VIP SHOP" };

export function slotPopup(balance: BalanceData, level: number, s: ShopSlotView, blocked = ""): ItemPopup {
  const t = slotTile(balance, level, s);
  const odds = s.item && isRandomItem(s.item) ? `<div class="sodds2"><b class="ifhead">What's inside</b>${oddsHtml(balance, s.item)}</div>` : "";
  const was = t.badge ? `<p class="swas"><s>${currencyIcon(s.currency, 14)}${priceText(s.basePrice)}</s>${tagHtml("new", t.badge)}</p>` : "";
  const where = s.gear ? "Goes to your Gear stash, unbound: the Trading Post buys it back."
    : s.item?.kind === "gear" ? "Goes to your Gear stash, bound."
      : s.item?.kind === "chest" || s.item?.kind === "luckyChest" ? `Opens at once: gear, gold and a speed-up at your level${s.shop === "vip" ? ", gear bound" : ""}.` : t.tile.detail;
  const body = s.gear ? `${itemBlockHtml(balance, s.gear)}${was}`
    : itemCardHtml({ well: itemWellOpts(t.tile, "lg"), name: t.tile.name, rarity: RARITY_KINDS.has(t.tile.kind) ? tileRarity(t.tile) : null, what: where, extra: `${was}${odds}` });
  const price = s.free ? FREE_PRICE : `${currencyIcon(s.currency, 20)} ${priceText(s.price)}`;   // MP-08: the free item
  return { title: SHOP_NAMES[s.shop], body, price, confirm: s.free ? "TAKE" : "BUY", blocked, className: `c-${s.currency}` };
}
